/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { IAwardKitSkuOption } from "Interfaces/SiteContent/IAwardKitSkuOption";

import {
  AWARD_KIT_SKU_LOAD,
  AWARD_KIT_SKU_LOAD_FAILURE,
  AWARD_KIT_SKU_LOAD_SUCCESS,
} from "./AwardKitSkuActionTypes";

/**
 * Action for getting the SKU
 */
export interface IGetAwardKitSku {
  type: typeof AWARD_KIT_SKU_LOAD;
}

/**
 * Action getting the SKU when successful
 */
export interface IGetAwardKitSkuSuccess {
  type: typeof AWARD_KIT_SKU_LOAD_SUCCESS;
  awardKitSku: IAwardKitSkuOption[];
}

/**
 * Action getting the SKU when failure
 */
export interface IGetAwardKitSkuFailure {
  type: typeof AWARD_KIT_SKU_LOAD_FAILURE;
  awardKitSkuLoadError: string;
}

/**
 * Action creator for getting the SKU
 */
export const getAwardKitSku = (): IGetAwardKitSku => ({
  type: AWARD_KIT_SKU_LOAD,
});

/**
 * Action creator for getting SKU when success
 * @param awardKitSku
 */
export const getAwardKitSkuSuccess = (
  awardKitSku: IAwardKitSkuOption[]
): IGetAwardKitSkuSuccess => ({
  type: AWARD_KIT_SKU_LOAD_SUCCESS,
  awardKitSku,
});

/**
 * Action creator for getting SKU when failure
 * @param awardKitSkuLoadError
 */
export const getAwardKitSkuFailure = (awardKitSkuLoadError: string): IGetAwardKitSkuFailure => ({
  type: AWARD_KIT_SKU_LOAD_FAILURE,
  awardKitSkuLoadError,
});

export type AwardKitSkuAction = IGetAwardKitSku | IGetAwardKitSkuSuccess | IGetAwardKitSkuFailure;
